module.exports = __webpack_public_path__ + "img/undraw_credit_card_payment_yb88.eed4d6ee.svg";